import { SOLR_SEARCH } from 'parmasottositi-theme/constants/ActionTypes';

const initialState = {
  loading: false,
  loaded: false,
  error: null,
  result: null,
};

export function solrSearchReducer(state = initialState, action = {}) {
  switch (action.type) {
    case `${SOLR_SEARCH}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${SOLR_SEARCH}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        result: action.result,
      };
    case `${SOLR_SEARCH}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
        result: null,
      };
    case `${SOLR_SEARCH}_RESET`:
      return { ...initialState };
    default:
      return state;
  }
}
